import {
  transformInitialStateTranslations,
  I18nTranslation,
} from '@crehana/i18n';

import { MAIN_MENU_TRANSLATION_KEY } from '@crehana/web/dist/MainMenu/constants';
import { CustomMainMenuLocales } from '@crehana/web/dist/MainMenu/types';

const useMainMenuTranslationsFromInitialState = (): CustomMainMenuLocales => {
  const unparsedInitialState =
    typeof window !== 'undefined' ? window.__INITIAL_STATE_UNPARSED__ : '';
  const initialState =
    typeof window !== 'undefined' ? window.__INITIAL_STATE__ : {};
  const rawInitialState = unparsedInitialState
    ? JSON.parse(unparsedInitialState)
    : initialState;
  const translationKeysFromInitialState =
    rawInitialState.translation_keys || {};

  const translationKeys = Array.isArray(translationKeysFromInitialState)
    ? transformInitialStateTranslations(translationKeysFromInitialState)
    : (translationKeysFromInitialState as I18nTranslation);

  return {
    es: {
      [MAIN_MENU_TRANSLATION_KEY]: {
        ...translationKeys[MAIN_MENU_TRANSLATION_KEY]?.es,
      },
    },
    pt: {
      [MAIN_MENU_TRANSLATION_KEY]: {
        ...translationKeys[MAIN_MENU_TRANSLATION_KEY]?.pt,
      },
    },
  };
};

export default useMainMenuTranslationsFromInitialState;
